import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { MoneyFormatted } from "app/components/MoneyFormatted";
import { CDate } from "app/common/CapitalDate";
import DeleteTransferModal from "../DeleteTransfer";
import NoRowsOverlay from "app/components/NoRowsOverlay";
import { IconButton } from "@mui/material";
const DesktopPendingTransfers = ({ pendingTransfers, interAccountAllowed, }) => {
    const [deleteFundsTransfer, setDeleteFundsTransfer] = React.useState(undefined);
    const rows = pendingTransfers.map((item) => item);
    const columns = [
        {
            field: "date",
            headerName: "Date",
            minWidth: 150,
            flex: 2,
            renderCell: (params) => (_jsx(CDate, { date: params.row.NextScheduledDate })),
        },
        {
            field: "receipt",
            headerName: "Receipt #",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => params.row.ReceiptNumber,
        },
        {
            field: "frequency",
            headerName: "Frequency",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => params.row.Frequency,
        },
        {
            field: "type",
            headerName: "Type",
            minWidth: 200,
            flex: 2,
            renderCell: (params) => (_jsxs(_Fragment, { children: [params.row.TransferTypeDescription, _jsx("br", {}), "From: ", params.row.FromAccountDescription, _jsx("br", {}), "\n To: ", params.row.ToAccountDescription] })),
        },
        {
            field: "amount",
            headerName: "Amount",
            minWidth: 150,
            flex: 2,
            renderCell: (params) => (_jsx(MoneyFormatted, { amount: params.row.Amount })),
        },
        {
            field: " ",
            headerName: " ",
            minWidth: 15,
            headerAlign: "center",
            align: "center",
            flex: 1,
            renderCell: (params) => (_jsx(_Fragment, { children: interAccountAllowed && (_jsx(IconButton, { "aria-label": "delete", id: "delete", onClick: () => setDeleteFundsTransfer(params.row.Id), children: _jsx(DeleteIcon, {}) })) })),
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Pending Transfers" }), _jsx("div", { children: _jsx(DataGridPro, { className: "custom-grid", autoHeight: true, sx: {
                        mt: 2,
                        mb: 6,
                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "8px" },
                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": { py: "15px" },
                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": { py: "22px" },
                    }, slots: {
                        noRowsOverlay: () => (_jsx(NoRowsOverlay, { children: "There are currently no pending transfers." })),
                    }, rows: rows, columns: columns, pagination: true, getRowId: (r) => r.Id, pageSizeOptions: [10, 25, 50], initialState: {
                        sorting: {
                            sortModel: [{ field: "date", sort: "desc" }],
                        },
                        pagination: {
                            paginationModel: { pageSize: 10 },
                        },
                    } }) }), _jsx(DeleteTransferModal, { fundsTransferId: deleteFundsTransfer, onClose: () => setDeleteFundsTransfer(undefined) })] }));
};
export default DesktopPendingTransfers;
